// src/components/Profile/MenuCard.jsx
import React from 'react';
import { Link } from 'react-router-dom';

export default function MenuCard({ activeSection, onSectionChange }) {
  return (
    <div className="menu-card card-animate">
      <div className="card-header">
        <h3>Account Settings</h3>
      </div>

      <div className="menu-list">
        <button
          className={`menu-item ${activeSection === 'profile' ? 'active' : ''}`}
          onClick={() => onSectionChange('profile')}
        >
          <i className="ph ph-user-circle"></i>
          <span>My Profile</span>
          <i className="ph ph-caret-right arrow"></i>
        </button>

        <button
          className={`menu-item ${activeSection === 'address' ? 'active' : ''}`}
          onClick={() => onSectionChange('address')}
        >
          <i className="ph ph-map-pin"></i>
          <span>Manage Addresses</span>
          <i className="ph ph-caret-right arrow"></i>
        </button>

        <button
          className={`menu-item ${activeSection === 'password' ? 'active' : ''}`}
          onClick={() => onSectionChange('password')}
        >
          <i className="ph ph-lock-key"></i>
          <span>Change Password</span>
          <i className="ph ph-caret-right arrow"></i>
        </button>

        <button
          className={`menu-item ${activeSection === 'wishlist' ? 'active' : ''}`}
          onClick={() => onSectionChange('wishlist')}
        >
          <i className="ph ph-heart"></i>
          <span>Wishlist</span>
          <i className="ph ph-caret-right arrow"></i>
        </button>

        {/* <Link to="#" className="menu-item">
          <i className="ph ph-bell"></i>
          <span>Notifications</span>
          <i className="ph ph-caret-right arrow"></i>
        </Link> */}
      </div>
    </div>
  );
}